const inputLabelFormParamEquip = {
  label: 'Tipo'
};

export default inputLabelFormParamEquip;
